import { getCountryName, getLanguageName, getLanguageTag } from "@trumpf/ux.i18n";
const getLanguageOptionName = (key) => {
    const locale = getLanguageTag(key).split("-");
    const languageName = getLanguageName(key) || key;
    if (locale.length < 2) {
        return languageName;
    }
    const countryName = getCountryName(key);
    return countryName ? `${languageName} (${countryName})` : languageName;
};
export const getLanguageOptions = (lngs) => {
    if (!lngs || lngs.length === 0) {
        return [];
    }
    let locales;
    if (typeof lngs === "string") {
        locales = lngs.split(",").map(getLanguageTag);
    }
    else if (Array.isArray(lngs)) {
        locales = lngs
            .map((lng) => {
            if (typeof lng === "string") {
                return getLanguageTag(lng);
            }
            if (typeof lng === "object" && lng.value) {
                return Object.assign(Object.assign({}, lng), { name: lng.name || getLanguageOptionName(lng.value), value: getLanguageTag(lng.value) });
            }
        })
            .filter((lng) => !!lng);
    }
    else {
        return [];
    }
    return locales.map((key) => {
        return typeof key === "object"
            ? key
            : {
                name: getLanguageOptionName(key),
                value: key
            };
    });
};
//# sourceMappingURL=utils.js.map
